import { Link } from "react-router-dom";
import { HeartIcon } from "@heroicons/react/24/solid";

export default function SuccessDonation() {
  return (
    <div className="pt-6 flex items-center justify-center px-4">
      <div className=" rounded-lg max-w-md w-full p-6 text-center space-y-6">
        <div className="flex justify-center text-bgCyan">
          <HeartIcon className="h-10 w-10" />
        </div>

        <h1 className="text-2xl font-bold text-gray-800">
          Merci pour votre générosité
        </h1>

        <p className="text-gray-600">
          Votre don a été reçu avec succès. Grâce à vous, nous pourrons
          organiser davantage d’événements au profit de la communauté
          québécoise.
        </p>

        <Link
          to="/"
          className="inline-block mt-4 px-6 py-3 bg-bgCyan text-white rounded-full hover:bg-hoverCyan transition"
        >
          Retour à l’accueil
        </Link>
      </div>
    </div>
  );
}
